import styled from 'styled-components';
import { Link } from 'gatsby';

export const LangLink = styled(Link)`
  padding: ${({ dir }) => (dir === 'rtl' ? '18px 10px 0 20px' : '18px 20px 0 12px')};
  display: flex;
  color: #fff;
  transition: 0.3s;
  text-decoration: none;
  background-color: transparent;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'DINRegular ' : 'GESSTwoDWTCLight,sans-serif ')};
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '16px')};
  letter-spacing: 0px !important;
  direction: ${({ dir }) => (dir === 'rtl' ? 'ltr' : 'rtl')};
  line-height: 1.1;
  @media (max-width: 1099px) {
    padding: ${({ dir }) => (dir === 'rtl' ? '0px 10px 0 20px' : '0px 20px 0 12px')};
  }
  &:hover {
    opacity: 0.7;
  }

  &.mbl_lang {
    display: none;

    @media (max-width: 1099px) {
      display: block;
      font-size: 16px;
      width: fit-content;
      direction: ${({ dir }) => (dir === 'rtl' ? 'rtl' : 'ltr')};
      position: relative;
      z-index: 10;
      top: 5px;
      &[dir=ltr] {
       margin-left: 12px;
      }
      &[dir=rtl] {
        margin-right: 12px;
      }
    }
  }

  &:after {
    background: url(/svg/sprites.svg#langea) no-repeat;
    width: 35px;
    height: 14px;
    content: '';
    background-size: 150px;
    display: block;
  }

  &.sec-lang {
    &:after {
      background: url(/svg/sprites.svg#langea) no-repeat;
    }
  }

  &[dir='ltr'] {
    min-width: 55px;
  }

  &[dir='rtl'] {
    min-width: 85px;

    &:after {
      content: 'English';
      background: none;
    }
  }
`;
